import {Tooltip} from "@mui/material";
import copy from "clipboard-copy";
import React, {useState} from "react";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    tooltip: {
        borderRadius: 0,
        fontWeight: 700,
        zIndex: 20000,
    }
}))

const CopyToClipboard = ({tooltipProps, children}) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const classes = useStyles();

    const onCopy = (content) => {
        void copy(content).then(() => {
            setShowTooltip(true);
        });
    }

    return (
        <Tooltip
            open={showTooltip}
            title={"Copied to clipboard!"}
            leaveDelay={1000}
            classes={{
                popper: classes.tooltip,
            }}
            onClose={() => setShowTooltip(false)}
            {...tooltipProps || {}}
        >
            {children({copy: onCopy})}
        </Tooltip>
    );
}

export default CopyToClipboard;
